import { CircularProgress, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { useGetTicket } from "hooks/useGetTicket";
import { TicketForm } from "./components/TicketForm";

/**
 * Страница деталей обращения. Заменила прежний модальный Dialog.
 *
 *   /admin/tickets/new   — создание (id отсутствует, форма работает в режиме создания)
 *   /admin/tickets/:id   — просмотр/редактирование существующего
 *
 * После создания нового тикета редиректит на детальную страницу созданного.
 */
const TicketDetailPage = () => {
    const navigate = useNavigate();
    const params = useParams<{ id: string }>();
    const isNewMode = !params.id || params.id === "new";

    const { data: ticket, isLoading, error } = useGetTicket(isNewMode ? undefined : params.id);

    const handleSave = ({ isNew, ticket: saved }: { isNew: boolean; ticket: any | null }) => {
        // Создали — переходим на /tickets/:newID, чтобы URL отражал состояние.
        if (isNew && saved?.id) {
            navigate(`/admin/tickets/${saved.id}`, { replace: true });
            return;
        }
        // Закрыли (saved=null) — возвращаемся к списку, чтобы не показывать сирую страницу
        // только что закрытого тикета.
        if (saved === null && !isNew) {
            navigate("/admin/tickets");
        }
        // В остальных случаях (обычный update) — остаёмся на странице. invalidateTicketQueries
        // внутри формы уже подтянет свежие данные.
    };

    if (!isNewMode && isLoading) {
        return (
            <div style={{ textAlign: "center", padding: 64 }}>
                <CircularProgress size={28} />
            </div>
        );
    }

    if (!isNewMode && error) {
        return (
            <div style={{ padding: 32 }}>
                <Button
                    size="small"
                    variant="text"
                    onClick={() => navigate("/admin/tickets")}
                    startIcon={<FaArrowLeft />}
                >
                    К списку обращений
                </Button>
                <div style={{ marginTop: 16, color: "#B91C1C" }}>
                    Не удалось загрузить обращение
                </div>
            </div>
        );
    }

    if (!isNewMode && !ticket) {
        return (
            <div style={{ padding: 32 }}>
                <Button
                    size="small"
                    variant="text"
                    onClick={() => navigate("/admin/tickets")}
                    startIcon={<FaArrowLeft />}
                >
                    К списку обращений
                </Button>
                <div style={{ marginTop: 16, color: "#64748B" }}>Обращение не найдено</div>
            </div>
        );
    }

    return (
        <div>
            <div style={{ marginBottom: 12 }}>
                <Button
                    size="small"
                    variant="text"
                    onClick={() => navigate("/admin/tickets")}
                    startIcon={<FaArrowLeft />}
                >
                    К списку обращений
                </Button>
            </div>

            <TicketForm ticket={isNewMode ? null : ticket || null} onSave={handleSave} />
        </div>
    );
};

export default TicketDetailPage;
